function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.set-prototype-of.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import ExtendableError from 'es6-error';
import stringifyNode from './lib/stringify-node';
export var MigrationError = /*#__PURE__*/function (_ExtendableError) {
  _inherits(MigrationError, _ExtendableError);

  var _super = _createSuper(MigrationError);

  function MigrationError() {
    _classCallCheck(this, MigrationError);

    return _super.apply(this, arguments);
  }

  return MigrationError;
}(ExtendableError);
export var ValidationError = /*#__PURE__*/function (_ExtendableError2) {
  _inherits(ValidationError, _ExtendableError2);

  var _super2 = _createSuper(ValidationError);

  function ValidationError(node) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _super2.call(this, node);
    _this.message = "node not valid: ".concat(stringifyNode(node)); // eslint-disable-line no-use-before-define

    return _this;
  }

  return ValidationError;
}(ExtendableError);
export var SemverValidationError = /*#__PURE__*/function (_ValidationError) {
  _inherits(SemverValidationError, _ValidationError);

  var _super3 = _createSuper(SemverValidationError);

  function SemverValidationError(message) {
    var _this2;

    _classCallCheck(this, SemverValidationError);

    _this2 = _super3.call(this, message);
    _this2.message = "Invalid simple semver: ".concat(message); // eslint-disable-line no-use-before-define

    return _this2;
  }

  return SemverValidationError;
}(ValidationError);